import Enumerable from "linq";
import { DateTimeStringUtility } from "../../../domain/system";
import {
  Holiday,
  IHolidayRepository,
} from "../../../domain/holiday";
import { AuthenticatedService } from "../..";
import { IHolidayBean } from "./beans";

export class HolidayRepository extends AuthenticatedService implements IHolidayRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getAllEntities(): Promise<Holiday[]> {
    const url = "/api/holidays";
    const result = await this.get(url);
    return this.toHolidays(result.data);
  }

  private toHolidays(beans: IHolidayBean[]) {
    return Enumerable.from(beans).select(b => this.toHoliday(b)).toArray();
  }

  toHoliday(bean: IHolidayBean): Holiday {
    const holiday = new Holiday(DateTimeStringUtility.toDateTimeValue(bean.targetDate), bean.comment, bean.deleted);
    Object.freeze(holiday);
    return holiday;
  }
}
